export default __webpack_public_path__ + "static/img/plus.98cd834.svg";